import React from 'react';

const tagConfig = {
    confirmationDelayed: {
        label: 'Confirmation Delayed',
        backgroundColor: '#FEF3C7',
        color: '#92400E',
        borderColor: '#FCD34D'
    },
    escalated: {
        label: 'Escalated',
        backgroundColor: '#FEE2E2',
        color: '#991B1B',
        borderColor: '#FCA5A5'
    },
    rescheduled: {
        label: 'Rescheduled',
        backgroundColor: '#DBEAFE',
        color: '#1E40AF',
        borderColor: '#93C5FD'
    },
    hclConcierge: {
        label: 'HCL Concierge',
        backgroundColor: '#DBEAFE',
        color: '#1E40AF',
        borderColor: '#93C5FD'
    }
    // Add more tag configurations as needed
};

const Tag = ({ label, backgroundColor, color, borderColor }) => (
    <span
        style={{
            backgroundColor: backgroundColor,
            color: color,
            border: `1px solid ${borderColor}`,
            borderRadius: '6px',
            fontSize: '11px',
            fontWeight: 600,
            padding: '4px 10px',
            marginRight: '6px',
            display: 'inline-block',
            marginBottom: '4px',
            lineHeight: '1.2',
            textTransform: 'capitalize',
            letterSpacing: '0.3px',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            whiteSpace: 'nowrap'
        }}
    >
        {label}
    </span>
);

const Tags = ({ data, tagKeys = [] }) => {
    const tags = [];
    
    // If specific tagKeys are provided, use them; otherwise use all from tagConfig
    const keysToCheck = tagKeys.length > 0 ? tagKeys : Object.keys(tagConfig);
    
    keysToCheck.forEach((key) => {
        if (data[key] === 1 && tagConfig[key]) {
            tags.push(
                <Tag
                    key={key}
                    label={tagConfig[key].label}
                    backgroundColor={tagConfig[key].backgroundColor}
                    color={tagConfig[key].color}
                    borderColor={tagConfig[key].borderColor}
                />
            );
        }
    });
    
    return (
        <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: '4px',
            alignItems: 'center'
        }}>
            {tags}
        </div>
    );
};

export default Tags;